module.exports = __webpack_public_path__ + "img/EN-邀请3.029f4c47.png";